import React from 'react';
import { useUser } from '@/contexts/UserContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';

const getInitials = (name: string) => {
  if (!name) return '';
  return name.split(' ').map(n => n[0]).join('').toUpperCase();
}

export default function MiPerfil() {
  const { currentUser, userProfile } = useUser();

  if (!currentUser || !userProfile) {
    return (
      <div className="flex items-center justify-center h-full">
        <p>No se ha encontrado información del usuario.</p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
        <div>
            <h1 className="text-3xl font-bold tracking-tighter">Mi Perfil</h1>
            <p className="text-muted-foreground mt-1">Consulta y gestiona la información de tu cuenta.</p>
        </div>

        <Card className="max-w-2xl mx-auto">
            <CardHeader>
                <div className="flex items-center space-x-4">
                    <Avatar className="h-16 w-16">
                        <AvatarImage src={userProfile.profile_image_url} alt={userProfile.nombre || ''} />
                        <AvatarFallback>{getInitials(userProfile.nombre || '')}</AvatarFallback>
                    </Avatar>
                    <div>
                        <CardTitle className="text-2xl">{userProfile.nombre || 'Sin nombre'}</CardTitle>
                        <CardDescription>{userProfile.email}</CardDescription>
                    </div>
                </div>
            </CardHeader>
            <CardContent className="space-y-4">
                 <div className="flex flex-col space-y-1">
                    <span className="text-sm font-semibold text-muted-foreground">NIF</span>
                    <p className="font-mono text-sm">{userProfile.nif || 'No especificado'}</p>
                </div>
                <div className="flex flex-col space-y-1">
                    <span className="text-sm font-semibold text-muted-foreground">Teléfono</span>
                    <p className="font-mono text-sm">{userProfile.telefono || 'No especificado'}</p>
                </div>
                <div className="flex flex-col space-y-1">
                    <span className="text-sm font-semibold text-muted-foreground">IBAN</span>
                    <p className="font-mono text-sm">{userProfile.iban || 'No especificado'}</p>
                </div>
                <div className="flex flex-col space-y-1">
                    <span className="text-sm font-semibold text-muted-foreground">Estado</span>
                     <p className="font-mono text-sm">
                        <Badge variant="success">Activo</Badge>
                    </p>
                </div>
            </CardContent>
        </Card>
    </div>
  );
}
